import { Component } from '@angular/core';

@Component({
  selector: 'app-new-claim',
  templateUrl: './new-claim.component.html',
  styleUrl: './new-claim.component.scss'
})
export class NewClaimComponent {

}
